
import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import { ConfirmationDialog } from "components";
import { PackageProps } from "../../../store/actionType";
import { deletePackage, resetPackage } from "../../../store/action";

interface CategoryProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  packageData: PackageProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CategoryProps;
const HandleDeletePackage: React.FC<Props> = ({
  closeModal,
  packageData,
  onDeletePackage,
  onResetPackage
}) => {
  const [error,setError] = useState("")
  const packageState = useSelector(
    (state: any) => state.packages.deletePackageState
  );
  
  const handleDeletePackage = async (e: FormEvent) => {
    e.preventDefault();
    onDeletePackage(packageData.id);
    closeModal(false)
  };
   useEffect(() => {
    onResetPackage()
      setError(packageState?.error);
    }, [packageState?.error]);
  return (
    <>
      <ConfirmationDialog
        title={`Delete ${packageData.name}`}
        message={"Are you sure you want to delete this package?"}
        onConfirm={handleDeletePackage}
        onCancel={closeModal}
        error={error}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeletePackage: (package_id: string) => dispatch(deletePackage(package_id)),
   onResetPackage: () => dispatch(resetPackage()),
});

export default connect(null, mapDispatchToProps)(HandleDeletePackage);
